
export const FETCH_AUTH_ITEMS = "FETCH_AUTH_ITEMS";
export const FETCH_AUTH_ITEMS_SUCCESS = "FETCH_AUTH_ITEMS_SUCCESS";
export const FETCH_AUTH_ITEMS_ERROR = "FETCH_AUTH_ITEMS_ERROR";
export const FETCH_AUTH_ITEMS_SAGA = "FETCH_AUTH_ITEMS_SAGA";
